import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CargoPaymentInfo } from 'src/app/models/cargo-payment-info.model';
import { SharedService } from 'src/app/services/shared-service/shared.service';

@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaymentSummaryComponent implements OnInit {
  @Input() cargoPaymentInfo: CargoPaymentInfo | undefined;
  currentLoadingState = false;
  buttonName = '';
  paymentType = '';

  constructor(public sharedService: SharedService) {}

  ngOnInit(): void {
    this.sharedService.currentNextButtonName.subscribe((buttonName) => (this.buttonName = buttonName));
    this.sharedService.currentPaymentType.subscribe((paymentType) => (this.paymentType = paymentType));
    this.sharedService.currentLoadingState.subscribe((currentLoadingState) => (this.currentLoadingState = currentLoadingState));
  }
}
